import React from "react";
const CollapsibleListContext = React.createContext(
  null
);
const CollapsibleListContextProvider = ({
  isExpanded,
  toggle,
  children
}) => {
  return /* @__PURE__ */ React.createElement(CollapsibleListContext.Provider, { value: { isExpanded, toggle } }, children);
};
export {
  CollapsibleListContext,
  CollapsibleListContextProvider
};
//# sourceMappingURL=collapsibleListContext.js.map
